var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoKey24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_key24x24",
    transform: "translate(-3.041 -2.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keyword",
    transform: "translate(3.041 2.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26430",
    "data-name": "Group 26430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46939",
    "data-name": "Path 46939",
    d: "M38.467,2.547,36.838,1.066a4.331,4.331,0,0,0-5.7,0,3.412,3.412,0,0,0-.376,4.775l-6.949,6.31a.489.489,0,0,0,0,.738l1.628,1.478a.618.618,0,0,0,.814,0l.408-.37L28.7,15.844a.618.618,0,0,0,.814,0l1.224-1.108-1.224-1.108a.489.489,0,0,1,0-.738.618.618,0,0,1,.814,0L31.551,14l1.224-1.108a.489.489,0,0,0,0-.738L30.739,10.3,33.2,8.061a4.347,4.347,0,0,0,5.263-.343,3.426,3.426,0,0,0,0-5.171ZM36.838,6.24a1.861,1.861,0,0,1-2.179.2c-.22-.134-1.7-1.5-1.892-1.674a1.468,1.468,0,0,1,0-2.215h0a1.856,1.856,0,0,1,2.443,0c.207.188,1.694,1.517,1.845,1.717a1.46,1.46,0,0,1-.217,1.976Z",
    transform: "translate(-23.645 .003)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoKey24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_key24x24.97d11e84cce522dbf117909d4dc7b7ba.svg";